export default "<p>pago-seguimiento works!</p>\r\n";